import {createReducer, on} from "@ngrx/store";
import * as ShipsActions from './ships.actions';
import {Ship} from "../../models/Ship";
export const ShipsFeatureKey = 'ships';
export const ShipsInitialState: Ship[] = [];
export const ShipsReducer = createReducer<Ship[]>(
  ShipsInitialState,
  on(ShipsActions.update, (_state, { ships }) => ships),
);
